package com.kinoshazam.view

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.BoldExtraLarge
import com.kinoshazam.uiKit.theme.BoldLarge
import com.kinoshazam.uiKit.theme.UiKitTheme

@Composable
fun ErrorView(
    textError: String,
    textAction: String,
    onAction: () -> Unit,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .fillMaxSize()
            .background(UiKitTheme.colors.color_3)
            .padding(40.dp),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier
                .clip(RoundedCornerShape(12.dp))
                .background(UiKitTheme.colors.color_4)
        ) {
            TextLabel(
                modifier = Modifier.padding(16.dp),
                state = TextLabelState(
                    text = textError,
                    color = UiKitTheme.colors.color_2,
                    textStyle = BoldExtraLarge,
                    textAlign = TextAlign.Center,
                ),
            )

            Spacer(
                modifier = Modifier.fillMaxWidth().height(2.dp)
                    .background(UiKitTheme.colors.color_3)
            )

            TextLabel(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable {
                        onAction()
                    }
                    .padding(16.dp),
                state = TextLabelState(
                    text = textAction,
                    color = UiKitTheme.colors.color_1,
                    textStyle = BoldLarge,
                    textAlign = TextAlign.Center,
                ),
            )
        }
    }
}
